export default {"src":"/_next/static/media/apple-logo.a59c9c25.svg","height":32,"width":27,"blurWidth":0,"blurHeight":0};